import MainLayout from '@/layouts/MainLayout.vue'

export default {
  path: '/carbon-accounting',
  component: MainLayout,
  redirect: '/carbon-accounting/home',
  meta: { module: 'carbonAccounting', title: '碳排放核算' },
  children: [
    {
      path: 'home',
      name: 'CarbonAccountingHome',
      component: () => import('@/views/carbon-accounting/Home.vue'),
      meta: { title: '首页' }
    },
    {
      path: 'boundary',
      name: 'CarbonAccountingBoundary',
      component: () => import('@/views/carbon-accounting/Boundary.vue'),
      meta: { title: '盘查边界管理' }
    },
    {
      path: 'report',
      name: 'CarbonAccountingReport',
      component: () => import('@/views/carbon-accounting/Report.vue'),
      meta: { title: '碳排放报告管理' }
    },
    {
      path: 'evaluation',
      name: 'CarbonAccountingEvaluation',
      component: () => import('@/views/carbon-accounting/Evaluation.vue'),
      meta: { title: '报告评价' }
    },
    {
      path: 'database',
      name: 'CarbonAccountingDatabase',
      component: () => import('@/views/carbon-accounting/Database.vue'),
      meta: { title: '基础数据库' }
    }
  ]
}
